import { render, staticRenderFns } from "./submitHospitalSuccess.vue?vue&type=template&id=5103ee33&scoped=true&"
import script from "./submitHospitalSuccess.vue?vue&type=script&lang=js&"
export * from "./submitHospitalSuccess.vue?vue&type=script&lang=js&"
import style0 from "./submitHospitalSuccess.vue?vue&type=style&index=0&id=5103ee33&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5103ee33",
  null
  
)

export default component.exports